// Sibling imports
const { UPDATE } = require('./actions')
const SelfUserRecord = require('./record')

function userReducer(state = new SelfUserRecord(), { type, payload }) {
  switch (type) {
    case UPDATE:
      return state.mergeDeep(payload)
    default:
      return state
  }
}

module.exports = userReducer
